import React from 'react'

const AssistantManagerDashboard = () => {
  return (
    <div>
      Assistant Manager Dashboard
    </div>
  )
}

export default AssistantManagerDashboard
